export default __webpack_public_path__ + "media/images/features/ja/ogp-e3b85ec86c2329ab4829116df58393e3.jpg";